<template>
  <div id="app">
    <div class="body_bg">
      <div class="container whitebg">
        <el-row :gutter="25">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <div class="grid-content bg-purple-light">
              <div class="side_con">
                <div class="side_container">
                  <div class="xbjj_con_title">
                    <span class="leftfloat">导出格式：{{ name }}</span>
                    <span class="rightfloat">
                      <el-button size="small" @click="copy">复制</el-button>
                      <el-button size="small" @click="Export">导出</el-button>
                    </span>
                    <div class="clearfix"></div>
                  </div>
                  <div class="xbjj_con fifth">
                    <!-- 导出内容 -->
                    <div
                      id="ctl00_cphContect_div"
                      name="ctl00_cphContect_div"
                      deep="7"
                      style="white-space: pre-wrap"
                    >
                      {{ datail }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Paper_export_detail',
  data() {
    return {}
  },
  props: {
    name: {
      type: String,
    },
    datail: {
      type: String,
    },
  },
  mounted() {},
  components: {},
  methods: {
    onSubmit() {},
    copy() {
      //复制
      this.$Download.copy(this.datail)
    },
    Export() {
      //文本导出
      this.$Download.funDownload(this.datail, this.name)
    },
  },
}
</script>

<style scoped></style>
